import ApiService from 'services/Api/ApiService'
import { getEnvConfig } from 'utils/getEnvConfig'
import { CreateOrderPayloadType } from 'experiments/StaffLink/StaffLink.types'
import { SavedCartItems } from 'services/Api/StaffLinkApiFolder/type'
import { ILocation } from 'experiments/StaffLinkOrder/helpers/geoLocation'
import { apiRequestInterceptor } from './StaffLink.helpers'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

let staffLinkProxy: string = ''
if (typeof window !== 'undefined') {
  if (window.location.origin.toString().includes('localhost')) {
    staffLinkProxy = getEnvConfig('STAFF_LINK_BASE_URL') || ''
  } else {
    staffLinkProxy = `${window.location.origin}/api/staff-link`
  }
}

const StaffLinkProxyApi = new ApiService(staffLinkProxy, headers)
StaffLinkProxyApi.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))

export const fetchCatalogItemsWebView = (
  businessId: string,
  linkId: string,
  accountId: string
): Promise<any> => {
  return StaffLinkProxyApi.postRequest('/app/orders/retailer/v1/ListInventoryItems', {
    business_id: businessId,
    list_id: linkId,
    account_id: accountId
  })
}

export const getStaffOrdersWebViewApi = (
  payload: Pick<CreateOrderPayloadType, 'customerId' | 'businessId'>
): Promise<any> => {
  const reqPayload = {
    business_id: payload.businessId,
    account_id: payload.customerId,
    start_time: undefined,
    end_time: undefined
  }
  return StaffLinkProxyApi.postRequest('/app/orders/retailer/v1/GetOrders', reqPayload)
}

export const createNewOrderWebViewApi = (
  payload: CreateOrderPayloadType,
  _?: ILocation,
  cartId?: string
): Promise<any> => {
  return StaffLinkProxyApi.postRequest('/app/orders/retailer/v1/CreateOrder', {
    order: payload,

    ...(cartId && { cart_id: cartId })
  })
}

export const updateOrderWebViewApi = (payload: CreateOrderPayloadType): Promise<any> => {
  return StaffLinkProxyApi.putRequest('/app/orders/retailer/v1/UpdateOrder', payload)
}

export const fetchCustomerCartWebviewApi = (payload: { customerId: string }) => {
  return StaffLinkProxyApi.getRequest(
    `/app/orders/retailer/v1/GetCart?customer_id=${payload.customerId}`,
    {}
  )
}

export const updateorCreateCartWebviewApi = (payload: {
  cart_id: string
  business_id: string
  customer_id: string
  items: SavedCartItems[]
}) => {
  return StaffLinkProxyApi.postRequest('/app/orders/retailer/v1/SetCart', payload)
}

export const updateStaffOrderWebviewApi = (payload: any): Promise<any> => {
  return StaffLinkProxyApi.putRequest('/app/orders/retailer/v1/UpdateOrder', payload)
}

export const getStaffBusinessLabelsKeyValWebviewApi = (accountId: string) => {
  return StaffLinkProxyApi.getRequest(
    `/app/orders/retailer/v1/GetSupplierLabelsKeyVals?account_id=${accountId}`,
    {}
  )
}
